module.exports = __webpack_public_path__ + "img/contact_icon_3.8eb1721e.png";